<div class="flex flex-col w-full min-h-full max-h-full">
  
 <!-- Header -->
 <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 dark:bg-gray-900 border-b">
  <div class="text-2xl font-medium">
    <span *ngIf="mode == 'create'">Dodaj konto bankowe</span>
    <span *ngIf="mode == 'update'">Aktualizacja konta bankowego</span>
  </div>
  <button mat-icon-button [matDialogClose]="undefined">
      <mat-icon class="dark:text-white" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
  </button>
</div>

 <!-- Content -->
 <div class="flex flex-auto overflow-hidden">
  <div class="flex flex-col flex-auto sm:mb-18 overflow-y-scroll sm:overflow-y-auto p-6">

    <div class="grid grid-cols-12 gap-3">

      <div class="col-span-12">
        <mat-form-field class="w-full" subscriptSizing="dynamic">
          <mat-label>Bank lub wyświetlana nazwa</mat-label>
          <input [formControl]="form.controls.bank" matInput type="text"/>
          <mat-hint>Nazwa banku będzie wysyłana do KSeF</mat-hint>
        </mat-form-field>
      </div>

      <div class="col-span-12" >
        <mat-form-field class="w-full" subscriptSizing="dynamic">
          <mat-label>Numer konta bankowego</mat-label>
          <input [formControl]="form.controls.accountNumber" matInput type="text" bankAccountFormat/>
        </mat-form-field>
      </div>

      <div class="col-span-12">
        <mat-checkbox [formControl]="form.controls.isVATAccount" color="primary">
          Konto VAT (automatycznie wybierane dla mechanizmu podzielonej płatności)
        </mat-checkbox>
      </div>

      <!-- Przycisk rozwijający pola KSeF -->
      <div class="col-span-12">
        <button mat-button type="button" (click)="toggleKsefFields()" class="text-primary">
          <mat-icon [svgIcon]="showKsefFields ? 'heroicons_outline:chevron-up' : 'heroicons_outline:chevron-down'"></mat-icon>
          {{ showKsefFields ? 'Ukryj dodatkowe pola KSeF' : 'Pokaż dodatkowe pola KSeF' }}
        </button>
      </div>

      <!-- Dodatkowe pola KSeF (opcjonalne) -->
      <ng-container *ngIf="showKsefFields">
        <div class="col-span-12 text-sm text-gray-500 dark:text-gray-400 mb-2">
          Poniższe pola są opcjonalne i będą wysyłane do KSeF wraz z numerem konta bankowego.
        </div>

        <div class="col-span-12 md:col-span-6">
          <mat-form-field class="w-full" subscriptSizing="dynamic">
            <mat-label>Kod SWIFT</mat-label>
            <input [formControl]="form.controls.swift" matInput type="text" maxlength="11" placeholder="np. BREXPLPWXXX"/>
            <mat-hint>8 lub 11 znaków</mat-hint>
          </mat-form-field>
        </div>

        <div class="col-span-12">
          <mat-form-field class="w-full" subscriptSizing="dynamic">
            <mat-label>Opis rachunku (KSeF)</mat-label>
            <input [formControl]="form.controls.accountDescription" matInput type="text" maxlength="256"/>
            <mat-hint>Opcjonalny opis rachunku wysyłany do KSeF</mat-hint>
          </mat-form-field>
        </div>

        <div class="col-span-12">
          <mat-form-field class="w-full" subscriptSizing="dynamic">
            <mat-label>Typ rachunku własnego banku</mat-label>
            <mat-select [formControl]="form.controls.bankOwnAccountType">
              <mat-option *ngFor="let type of bankOwnAccountTypes" [value]="type.value">
                {{ type.label }}
              </mat-option>
            </mat-select>
            <mat-hint>Dotyczy tylko rachunków własnych banków i SKOK - dla zwykłych firm nie używane</mat-hint>
          </mat-form-field>
        </div>
      </ng-container>

    </div>
 
</div>
</div>

<!-- Footer -->
<div  class="absolute inset-x-0 bottom-0 py-4 pr-4 pl-1 sm:pr-8 sm:pl-7 border-t z-10 bg-gray-50 dark:bg-gray-900">
  <div class="flex items-end">
      <div class="ml-auto">
        <button mat-flat-button color="primary" *ngIf="mode == 'create'" [disabled]="form.invalid"  (click)="create()">
          Dodaj konto
        </button>
        <button mat-flat-button color="primary" *ngIf="mode == 'update'" [disabled]="form.invalid" (click)="update()">
          Zapisz zmiany
        </button>

          <button mat-button *ngIf="mode == 'update'" (click)="showDeleteConfirmation()" color="warn" class="ml-2">
            Usuń
          </button>

          <button mat-flat-button (click)="close()" class="ml-2">Zamknij</button>
      </div>
  </div>
</div>

</div>
